import { Splide } from '@splidejs/splide';

export const init = () => {
  const initializeCarousels = (container) => {
    const carousels = container.querySelectorAll('.carousel_type-16');
    if (carousels.length === 0) return;

    carousels.forEach((carousel) => {
      const splideOptions = {
        type: 'fade',
        arrows: false,
        pagination: true,
        drag: false
      }
      const splide = new Splide(carousel, splideOptions).mount();
      const { Controller } = splide.Components;
      const arrowLeft = carousel.querySelector('.button--prev');
      const arrowRight = carousel.querySelector('.button--next');

      if (splide.length === 1) {
        carousel.classList.add("just-one-slide");
      }


      const handleArrowsState = () => {
        const isStart = Controller.getIndex() === 0;
        const isEnd = Controller.getIndex() === Controller.getEnd();
        arrowLeft.classList.toggle('disabled', isStart);
        arrowRight.classList.toggle('disabled', isEnd);
      }

      splide.on('move', handleArrowsState);
      arrowLeft.addEventListener('click', () => { Controller.go('<'); });
      arrowRight.addEventListener('click', () => { Controller.go('>'); });
    });
  }

  initializeCarousels(document.body);
}